import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

var store = new Vuex.Store({

	state: {
		type: 0
	},

	getters: {

		type: function(state) {

			return state.type

		}

	},

	mutations: {

		type: function(state, value) {

			state.type = value

		}

	}

})

export default store